import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import { ISelectOptionProps } from 'components/form/types';
import { useQuery } from 'react-query';
import CreateForm from './components/CreateForm';

const Screen: FC = () => {
  const {
    isLoading: isLoadingTypes,
    error: errorTypes,
    data: typeOptions,
  } = useQuery<ISelectOptionProps[], Error>(
    ['companyTypeOptions'],
    (): Promise<ISelectOptionProps[]> => API.get<ISelectOptionProps[]>('clients/types').then(res => res.data)
  );

  const {
    isLoading: isLoadingLangOptions,
    error: errorLang,
    data: langOptions,
  } = useQuery<ISelectOptionProps[], Error>(
    ['companyDefaultLangOptions'],
    (): Promise<ISelectOptionProps[]> =>
      API.get<ISelectOptionProps[]>('clients/default-languages').then(res => res.data)
  );

  return (
    <MainLayout
      title="Добавяне на клиент"
      isLoading={isLoadingTypes && isLoadingLangOptions}
      error={errorTypes}
    >
      {typeOptions && langOptions && (
        <CreateForm
          typeOptions={typeOptions}
          langOptions={langOptions}
        />
      )}
    </MainLayout>
  );
};

export default Screen;
